<template>
  <div id="app">
    <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>

export default {
  name: 'app'
}
</script>

<style>
*{
  padding: 0;
  margin: 0;
}
*{
  -webkit-touch-callout:none; /*系统默认菜单被禁用*/
  -webkit-user-select:none; /*webkit浏览器*/
  -khtml-user-select:none; /*早期浏览器*/
  -moz-user-select:none;/*火狐*/
  -ms-user-select:none; /*IE10*/
  user-select:none; /*用户禁止选中*/
  -webkit-user-drag: none;/*用户禁止拖拽*/
  user-drag: none;/*用户禁止拖拽*/
}
input{
  -webkit-user-select:auto; /*webkit浏览器*/
}
textarea{
  -webkit-user-select:auto; /*webkit浏览器*/
}
#app{
  height: 100%;
}
body{
  display: block;
  height: 100%;
  margin: 0;
  padding: 0;
  background-color: #f4f5f7;
}
html {
  height: 100%;
}
</style>
